import style from './BulletRow.css';
import { renderIf } from '../../../utils/render.utils';

const RowType = {
  INFO: 'info',
  ERROR: 'error',
};

export default function BulletRow({
  type = RowType.INFO,
  title,
  subtitle,
  icon,
}) {
  return (
    <div className={style.row}>
      {renderIf(icon, <div className={style.icon}>{icon}</div>)}
      <div className={style.content}>
        <span className={style.title}>{title}</span>
        <span
          className={`${style.subtitle} ${
            type === RowType.ERROR ? style['error-subtitle'] : ''
          }`}
        >
          {subtitle}
        </span>
      </div>
    </div>
  );
}

BulletRow.Type = RowType;
